var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevronDoubleLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M11.898 6.524a.7.7 0 0 1-.036.989L7.03 12l4.832 4.487a.7.7 0 0 1-.953 1.026l-5.385-5a.7.7 0 0 1 0-1.026l5.385-5a.7.7 0 0 1 .99.037m5.616 0a.7.7 0 0 1-.037.989L12.645 12l4.832 4.487a.7.7 0 0 1-.953 1.026l-5.384-5a.7.7 0 0 1 0-1.026l5.384-5a.7.7 0 0 1 .99.037",
  clipRule: "evenodd"
})));
export default SvgChevronDoubleLeft;